var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "tick"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.21286104,12.2349907 C6.92221927,11.9630987 6.46656351,11.9780996 6.19467638,12.2668673 C5.92278446,12.5575091 5.93778529,13.0131648 6.22655304,13.285052 L10.0667667,16.8852523 C10.3761583,17.1758941 10.8674513,17.1365175 11.1280578,16.8027453 L17.8484317,8.16226453 C18.0921941,7.847247 18.0359397,7.39532585 17.7227991,7.15156829 C17.4077816,6.90780593 16.9558604,6.96406026 16.7121029,7.27720088 L10.4755959,15.295087 L7.21286104,12.2349907 Z",
    id: "Shape",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.cac324840e94714def8b217ef1d48dbc.svg";
export { ForwardRef as ReactComponent };